import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { GoogleSignInButton } from "@/components/GoogleSignInButton";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back");
      const to = loc.state?.from || "/portal";
      navigate(to);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-20">
      <p className="text-xs tracking-[0.3em] uppercase text-[#C86650] mb-2">Member Portal</p>
      <h1 className="font-serif text-4xl text-[#1A2421] mb-2">Welcome back.</h1>
      <p className="text-[#5C6A64] mb-8">Sign in to access your dashboard.</p>
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl border border-[#D5CFC4] space-y-5 shadow-[0_8px_30px_rgba(44,76,59,0.06)]">
        <GoogleSignInButton />
        <div className="flex items-center gap-4 text-xs text-[#5C6A64]">
          <div className="h-px flex-1 bg-[#D5CFC4]" />
          <span>or continue with email</span>
          <div className="h-px flex-1 bg-[#D5CFC4]" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Email</label>
          <Input
            data-testid="login-email"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-2 rounded-xl h-11 bg-white border-[#D5CFC4]"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Password</label>
          <Input
            data-testid="login-password"
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="mt-2 rounded-xl h-11 bg-white border-[#D5CFC4]"
          />
        </div>
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-full h-12 bg-[#2C4C3B] hover:bg-[#233D2F]">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
        <p className="text-sm text-[#5C6A64] text-center">
          New homeowner? <Link data-testid="link-register" to="/register" className="text-[#C86650] underline">Register</Link>
        </p>
      </form>
    </div>
  );
}
